import React, { useEffect } from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { TrackPerformanceTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import { MMMTab } from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";
import { IconButton } from "@shared/buttons";

import {
  usePerformanceTrackingChartMetric,
  usePerformanceTrackingChartView,
} from "../../hooks/use-chart-state";

/* eslint-disable max-len */
const ChartAggregateMetricIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.2754 0.416016L15.2051 1.3457L9.51758 7.0332L6.01758 3.5332L1.72461 7.82617L0.794922 6.89648L6.01758 1.67383L9.51758 5.17383L14.2754 0.416016Z" />
    <path d="M14.2754 4.17383L15.2051 5.10352L9.51758 10.791L6.01758 7.29102L1.72461 11.584L0.794922 10.6543L6.01758 5.43164L9.51758 8.93164L14.2754 4.17383Z" />
    <path d="M14.2754 8.17383L15.2051 9.10352L9.51758 14.791L6.01758 11.291L1.72461 15.584L0.794922 14.6543L6.01758 9.43164L9.51758 12.9316L14.2754 8.17383Z" />
  </svg>
);

const ChartSplitMetricIcon = (
  <svg
    width="16"
    height="8"
    viewBox="0 0 16 8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.2754 0.294922L15.2051 1.22461L9.51758 6.91211L6.01758 3.41211L1.72461 7.70508L0.794922 6.77539L6.01758 1.55273L9.51758 5.05273L14.2754 0.294922Z" />
  </svg>
);

export const ChartViewsButtons = () => {
  const trackMMMEvent = useTrackMMMEvent(MMMTab.TRACK_PERFORMANCE);
  const [chartView, setChartView] = usePerformanceTrackingChartView();
  const [metric] = usePerformanceTrackingChartMetric();
  const isAggregate = chartView === "aggregate";
  const isSplit = chartView === "split";
  const isChartViewHidden = metric === "kpi";
  useEffect(() => {
    if (isChartViewHidden && isSplit) {
      setChartView("aggregate");
    }
  }, [isChartViewHidden, setChartView, isSplit]);

  if (isChartViewHidden) {
    return null;
  }

  return (
    <div className="flex flex-col justify-between">
      <div className="font-bold text-xs mb-0.5">CHART VIEW</div>
      <div className="flex space-x-2">
        <GenericTooltip content="Aggregate" noInfoCircle mouseEnterDelay={0.1}>
          <IconButton
            className={clsx(
              {
                "fill-white bg-cosmic border-transparent": isAggregate,
                "fill-interstellar hover:bg-cosmic-4 hover:border-cosmic+1":
                  !isAggregate,
              },
              "p-2 border rounded-lg h-full",
            )}
            onClick={() => {
              if (isAggregate) {
                return;
              }

              trackMMMEvent({
                component:
                  TrackPerformanceTrackedComponent.SPEND_CHART_AGGREGATE_SELECTOR,
                action: "onClick",
              });

              setChartView("aggregate");
            }}
          >
            {ChartSplitMetricIcon}
          </IconButton>
        </GenericTooltip>
        <GenericTooltip content="Split" noInfoCircle mouseEnterDelay={0.1}>
          <IconButton
            className={clsx(
              {
                "fill-white bg-cosmic border-transparent": !isAggregate,
                "fill-interstellar hover:bg-cosmic-4 hover:border-cosmic+1":
                  isAggregate,
              },
              "p-2 border rounded-lg h-full",
            )}
            onClick={() => {
              if (isSplit) {
                return;
              }

              trackMMMEvent({
                component:
                  TrackPerformanceTrackedComponent.SPEND_CHART_SPLIT_SELECTOR,
                action: "onClick",
              });

              setChartView("split");
            }}
          >
            {ChartAggregateMetricIcon}
          </IconButton>
        </GenericTooltip>
      </div>
    </div>
  );
};
